"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontSelector = void 0;
var fontSelector = function (props, font) {
    return props.theme.variables.fonts[font];
};
exports.fontSelector = fontSelector;
var getFont = function (font) {
    return function (props) { return exports.fontSelector(props, font); };
};
exports.default = getFont;
//# sourceMappingURL=index.js.map